import { render } from "./Extend.vue?vue&type=template&id=0d55b92f&scoped=true"
import script from "./Extend.vue?vue&type=script&lang=js"
export * from "./Extend.vue?vue&type=script&lang=js"

import "./Extend.vue?vue&type=style&index=0&id=0d55b92f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d55b92f"]])

export default __exports__